// src/App.tsx
import React, { useState } from "react";
import SovereignCloudConnector from "./sovereigncloudconnector";
import RegulatoryOverview from "./RegulatoryOverview";
import Datenschutzerklaerung from "./components/Datenschutzerklaerung";
import { ComparisonModeSelector } from "./components/ComparisonModeSelector";
import { WorkplaceComparison } from "./components/workplace/WorkplaceComparison";
import { LanguageProvider } from "./i18n/LanguageContext";

type AppPage = "landing" | "cloud" | "workplace" | "regulatory" | "datenschutz";

export default function App() {
  const [page, setPage] = useState<AppPage>("landing");

  return (
    <LanguageProvider>
      {page === "regulatory" ? (
        <RegulatoryOverview onBack={() => setPage("landing")} />
      ) : page === "datenschutz" ? (
        <Datenschutzerklaerung onBack={() => setPage("landing")} />
      ) : page === "cloud" ? (
        <SovereignCloudConnector
          onOpenRegulatory={() => setPage("regulatory")}
          onBack={() => setPage("landing")}
          onSwitchToWorkplace={() => setPage("workplace")}
        />
      ) : page === "workplace" ? (
        <WorkplaceComparison
          onBack={() => setPage("landing")}
          onOpenRegulatory={() => setPage("regulatory")}
          onSwitchToCloud={() => setPage("cloud")}
          onOpenDatenschutz={() => setPage("datenschutz")}
        />
      ) : (
        <ComparisonModeSelector
          onSelectCloud={() => setPage("cloud")}
          onSelectWorkplace={() => setPage("workplace")}
          onOpenRegulatory={() => setPage("regulatory")}
        />
      )}
    </LanguageProvider>
  );
}